export default "__VITE_ASSET__$yk01GsC__"